// Sanitize input value
export const sanitizeValue = (val) => (typeof val === "string" ? val.trim() : val);

// Validate step input
export const validateStepInput = (key, value) => {
  const v = sanitizeValue(value);
  switch (key) {
    case "firstName":
    case "lastName": {
      const nameOk = /^[A-Za-z\s'.-]{2,50}$/.test(v);
      if (!nameOk) return { ok: false, error: "Name must be 2-50 letters only." };
      return { ok: true, value: v };
    }
    case "mobileNumber": {
      const numOk = /^\d{10}$/.test(v);
      if (!numOk) return { ok: false, error: "Mobile number must be exactly 10 digits." };
      return { ok: true, value: v };
    }
    case "loanAmount": {
      const num = Number(v);
      if (!Number.isFinite(num) || num <= 0 || num > 1_000_000_000) {
        return { ok: false, error: "Loan amount must be a positive number up to 1,000,000,000." };
      }
      return { ok: true, value: num };
    }
    case "pincode": {
      const pincodeOk = /^\d{6}$/.test(v);
      if (!pincodeOk) return { ok: false, error: "Pincode must be exactly 6 digits." };
      return { ok: true, value: v };
    }
    default:
      return { ok: true, value: v };
  }
};

// Normalize lead payload
export const normalizeLeadPayload = (payload) => ({
  firstName: sanitizeValue(payload.firstName),
  lastName: sanitizeValue(payload.lastName),
  mobileNumber: sanitizeValue(payload.mobileNumber),
  loanType: sanitizeValue(payload.loanType),
  loanAmount: typeof payload.loanAmount === "number" ? payload.loanAmount : Number(payload.loanAmount),
  pincode: sanitizeValue(payload.pincode) || ""
});

// Validate lead payload
export const validateLeadPayload = (payload, loanTypeOptions) => {
  const p = normalizeLeadPayload(payload);
  if (!p.firstName || !p.lastName || !p.mobileNumber || !p.loanType || !Number.isFinite(p.loanAmount)) {
    return { ok: false, error: "Missing required information. Please complete all fields." };
  }
  if (!/^[A-Za-z\s'.-]{2,50}$/.test(p.firstName)) {
    return { ok: false, error: "First name must be 2-50 letters only." };
  }
  if (!/^[A-Za-z\s'.-]{2,50}$/.test(p.lastName)) {
    return { ok: false, error: "Last name must be 2-50 letters only." };
  }
  if (!/^\d{10}$/.test(p.mobileNumber)) {
    return { ok: false, error: "Mobile number must be exactly 10 digits." };
  }
  if (!loanTypeOptions.includes(p.loanType)) {
    return { ok: false, error: "Please select a valid loan type." };
  }
  if (p.loanAmount <= 0 || p.loanAmount > 1_000_000_000) {
    return { ok: false, error: "Loan amount must be a positive number up to 1,000,000,000." };
  }
  if (p.pincode && !/^\d{6}$/.test(p.pincode)) {
    return { ok: false, error: "Pincode must be exactly 6 digits." };
  }
  return { ok: true, payload: p };
};

